<script>
	import { pages } from '../share/stores';
	import { navigateToLastPage } from "../share/pages";

	import Pages from './Pages.svelte';
	import SmartLink from "../helpers/SmartLink.svelte";

	function pageAsBodyClass() {
		Array.from(document.body.classList).forEach(className => {
			if(className.indexOf('page_') > -1) {
				document.body.classList.remove(className);
			}
		})

		if(now.length > 0) {
			let nowName = now[0].path.split('/');
			nowName = nowName[nowName.length - 1];
			nowName = nowName.split('#')[0];
			if(nowName != '') {
				document.body.classList.add('page_' + nowName);
			} else {
				document.body.classList.add('page_index');
			}
		}
	}

	$:use = $pages;
	$:off = use ? use.slice(0, use.length - 2) : [];
	$:prev = use[use.length - 2] ? [use[use.length - 2]] : [];
	$:now = use[use.length - 1] ? [use[use.length - 1]] : [];
	$:updateBodyClass = now && pageAsBodyClass();

	let rightSideRendered = false;
</script>

<div class="container
			{use.length > 1 ? ' multiplePages' : ''}
	">
	<div class="left" on:click={navigateToLastPage}>
		{#if use.length > 1}
			<SmartLink callBack={() => {}} url={prev.path || '/'}>
				<Pages isRightSide={false} {rightSideRendered} name="prev" showCloseButton={true}
					   closeButtonClasses="close right"
						closeButtonText=""
					   usePages={prev}/>
			</SmartLink>
		{/if}
	</div>
	<div class="right">
		<Pages isRightSide={true} bind:rightSideRendered name="now" usePages={now}/>
	</div>
</div>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";
	
	.container {
		order: 2;
		width: 100vw;
		height: 100%;
		display: grid;
		grid-template-columns: 0 0 minmax(auto, var(--max-main-width)) auto 0;

		@include for-desktop-up {
			grid-template-columns: 0 0 minmax(auto, var(--max-main-width)) auto 0;
		}

		&.multiplePages {
		transition: grid var(--animation-duration) linear, transform var(--animation-duration) linear;
			grid-template-columns:
				0
				0
				minmax(auto, var(--max-main-width))
				auto
				0;

			@include for-tablet-landscape-up {
				grid-template-columns:
					minmax(10vw, calc((100% - var(--max-main-width)) / 2))
					0
					minmax(auto, var(--max-main-width))
					auto
					0;
			}

			@include for-desktop-up {
				// keep the "now"-page centered:
				grid-template-columns:
					minmax(calc(16rem + var(--spacing-mobile)), calc((100% - var(--max-main-width)) / 2))
					0
					minmax(auto, var(--max-main-width))
					minmax(0, 5vw)
					minmax(0, calc((100% - var(--max-main-width)) / 2));
			}
		}
		
		&.topNavigationVisible {

			@include for-desktop-up {
				// remove the left side if Navigation opened up and only one page present:
				grid-template-columns:
					0
					0
					minmax(auto, var(--max-main-width))
					minmax(0, 5vw)
					minmax(0, calc((100% - var(--max-main-width)) / 2));
			}
		}
	}
	
	.left {
		grid-column: 1 / span 2;
		position: relative;
		cursor: pointer;
		
		@include hide-scrollbar;
		
		:global(.scrollbox) {
			width: 90vw;
			max-width: var(--max-main-width);
			right: 0;
		}

		:global(> div) {
			height: 100%;
		}
		:global(> div button) {
			width: 100%;
			height: 100%;
		}

		.outer, .outer * {
			pointer-events: none !important;
		}

		button.close {
			width: 0.9em;
			height: 0.9em;
			border-radius: 50%;
			background-color: var(--color-burgeins-6);
			position: absolute;
			left: 50%;
			top: 10%;
			transform: translateX(50%) translateY(50%);
			border: none;
			display: none;
			z-index: 100;

			@include for-tablet-landscape-up {
				display: block;
			}

			:global(svg) {
				width: 70%;
				height: 70%;
				fill: white;
			}
		}
	}
	
	.right {
		position: relative;
		
		grid-column: 3 / span 3;
		
		@include hide-scrollbar;
		
		:global(.scrollbox) {
			max-width: var(--max-main-width);
		}
		
		.content {
			max-width: var(--max-main-width);
			height: 12.5em;
			position: relative;
			padding-left: 10%;
		}
	}
	
	.background {
		grid-column: 4 / span 2;
	}
	
	.left, .right, .background {
		height: 100%;
		overflow-x: hidden;
	}
</style>
